import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAllUrl () {
    return axios.post(global.BASE_ACL + '/url/findAllUrl')
  },
  urlUpdate (param) {
    return axios.post(global.BASE_ACL + '/url/updateUrl', param)
  },
  urlRefresh () {
    return axios.post(global.BASE_ACL + '/url/refreshUrl')
  }
}



// WEBPACK FOOTER //
// ./src/request/syssetting/urlList.js